var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#F9F9F9",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.666 29.3334L33.5526 36.954C34.4341 37.5711 34.8749 37.8796 35.3544 37.9991C35.7779 38.1047 36.2208 38.1047 36.6443 37.9991C37.1238 37.8796 37.5646 37.5711 38.4461 36.954L49.3327 29.3334M29.066 46.6667H42.9327C45.1729 46.6667 46.293 46.6667 47.1486 46.2307C47.9013 45.8472 48.5132 45.2353 48.8967 44.4827C49.3327 43.627 49.3327 42.5069 49.3327 40.2667V31.7334C49.3327 29.4932 49.3327 28.3731 48.8967 27.5174C48.5132 26.7648 47.9013 26.1528 47.1486 25.7693C46.293 25.3334 45.1729 25.3334 42.9327 25.3334H29.066C26.8258 25.3334 25.7057 25.3334 24.8501 25.7693C24.0974 26.1528 23.4855 26.7648 23.102 27.5174C22.666 28.3731 22.666 29.4932 22.666 31.7334V40.2667C22.666 42.5069 22.666 43.627 23.102 44.4827C23.4855 45.2353 24.0974 45.8472 24.8501 46.2307C25.7057 46.6667 26.8258 46.6667 29.066 46.6667Z",
    stroke: "#6583FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3ec8aa58d515dacf79b424b0ff419898.svg";
export { ForwardRef as ReactComponent };